import { render, staticRenderFns } from "./EndingSection.vue?vue&type=template&id=385f9187&"
import script from "./EndingSection.vue?vue&type=script&lang=js&"
export * from "./EndingSection.vue?vue&type=script&lang=js&"
import style0 from "./EndingSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports